import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import { Paper, Divider, IconButton } from '@material-ui/core';
import {Text, Button} from 'components/core';
import AddIcon from '@material-ui/icons/Add';
import CloseIcon from '@material-ui/icons/Close';
import clsx from 'clsx';

const detailWidth = 500;

const overrideStyle = makeStyles((theme) => ({
    paper: {
      height: '100vh',
      // position: 'fixed',
      width: '100%',
      display: 'flex',
      flexDirection: 'row'
    },
    main:
    {
       flexGrow: 1,
       flexShrink: 1,
    },
    detail:
    {
      flexBasis: detailWidth,
      flexGrow: 0,
      flexShrink: 0,
      width: 0,
      opacity: 1,
      '&.hidden':
      {
        opacity: 0,
        flexBasis: 0
      },
      '&.hidden *':
      {
        display: 'none'
      },
    },
    header:
    {
      height: 127
    },
    titleRow:
    {
      padding: 20, 
      display: 'flex',
      height: 80
    },
    title:
    {
      margin: 0,
      flexGrow: 1,
      minWidth: 0,
      '& h1':
      {
        margin: 0
      }
    },
    textDetailTitle: {
      color: theme.palette.text.secondary,
      fontSize: 15,
      fontWeight: 500,
      textTransform: "uppercase",
      padding: 12
    },
    button:
    {
      flexBasis: 200
    },
    closeButton:
    {
      flexBasis: 50
    },
    content: {
      height: 'calc(100vh - 128px)'
    }
  }), {name: "RaymanSection"});

function SectionMain({title, buttonLabel, tabs, children, detail, showDetail, onButtonClick, buttonDisabled = false, buttonHidden = false})
{
    const classes = overrideStyle();

    return <Paper square className={classes.paper}>
      <div className={classes.main}>
        <header className={classes.header}>
          <div className={classes.titleRow}>
            <div className={clsx(classes.title)}>
              <Text title>{title}</Text>
            </div>
            <div className={classes.button}>
              {buttonLabel && !buttonHidden ? <Button disabled={buttonDisabled} startIcon={<AddIcon fontSize="large" />} onClick={onButtonClick}>{buttonLabel}</Button> : null}
            </div>
          </div>
          <div className={classes.tabsRow}>
            {tabs}
          </div>
        </header>
        <Divider />
        <div className={classes.content}>
          {children}
        </div>
      </div>
      {showDetail ? <>
      <Divider orientation="vertical" />
      <div className={clsx(classes.detail, {hidden: !showDetail })}>
        {detail}
      </div>
      </> : null}
    </Paper>
}

function SectionDetail({header, tabs, children, onCloseClick})
{
    const classes = overrideStyle();

    return <Paper square className={classes.paper}>
      <div className={classes.detail}>
        <header className={classes.header}>
          <div className={classes.titleRow}>
            <div className={clsx(classes.title, typeof(header) === String ? classes.textDetailTitle : null)}>
              {header}
            </div>
            <div className={classes.closeButton}>
              <IconButton onClick={onCloseClick}><CloseIcon /></IconButton>
            </div>
          </div>
          <div className={classes.tabsRow}>
            {tabs}
          </div>
        </header>
        <Divider />
        <div className={classes.content}>
          {children}
        </div>
      </div>
    </Paper>
}

export {SectionMain, SectionDetail};